import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const llmApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    callLLM: builder.mutation({
      query: body => ({
        url: 'llm_call/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['LLMCall'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCallLLMMutation
} = llmApi;

